export default __webpack_public_path__ + "static/media/head02_ja_pc.2c588f3d.png";